export type LatchKeyType = string | string[]

const permission = (latchkey: LatchKeyType, type: 'and' | 'or', roles: string[]) => {
  if (typeof latchkey === 'string') {
    return roles.indexOf(latchkey) > -1
  }

  if (Array.isArray(latchkey)) {
    if (type === 'or') {
      return latchkey.some(key => {
        return roles.indexOf(key) > -1
      })
    }
    return latchkey.every(key => {
      return roles.indexOf(key) > -1
    })
  }

  return false
}

/**
 * 判断权限
 * @param latchkey 当前需要判断的key
 * @param type 当 latchkey 是数组的时候，latchkey 决定怎么与 roles 匹配。默认 and，代表必须全部匹配；or 代表有且只有一个
 * @param roles key 列表
 */
export const hasPermission = (latchkey: LatchKeyType, type: 'and' | 'or', roles: string[]) => {
  return permission(latchkey, type, roles)
}

export class PermissionError extends Error {
  constructor(message = '抱歉，权限不足', ...params: any[]) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PermissionError)
    }

    // Custom debugging information
    this.message = message
    this.name = 'PermissionError'
  }
}
